import { useLayoutEffect, useState } from "react";
import FormSection from "./sections/FormSection";
import GridSection from "./sections/GridSection";
import CartSection from "./sections/CartSection";
import LandingSection from "./sections/LandingSection";

/* =============================================
   LAYOUT ENGINE
   Reads screen JSON → renders sections
   Supports: 1-col, 2-col, 3-col layouts
   ============================================= */
const LAYOUT_COLS = { "1-col": 1, "2-col": 2, "3-col": 3 };

const SHOP_FILTERS_LAYOUT = "lfx-shop-filters-layout";

function shopFiltersStartCompact(screen, moduleName) {
  if (moduleName !== "products" || !screen?.sections?.length) return false;
  return screen.sections.some(
    (s) => s.type === "form" && String(s.id || "") === "products" && s.initiallyHidden === true
  );
}

export default function LayoutEngine({ screen, actions, moduleName }) {
  const [filtersCompact, setFiltersCompact] = useState(() => shopFiltersStartCompact(screen, moduleName));

  useLayoutEffect(() => {
    setFiltersCompact(shopFiltersStartCompact(screen, moduleName));
  }, [screen, moduleName]);

  useLayoutEffect(() => {
    if (moduleName !== "products") return;
    const onLayout = (e) => setFiltersCompact(!!e.detail?.compact);
    window.addEventListener(SHOP_FILTERS_LAYOUT, onLayout);
    return () => window.removeEventListener(SHOP_FILTERS_LAYOUT, onLayout);
  }, [moduleName]);

  if (!screen) return null;

  const cols = LAYOUT_COLS[screen.layout] || 1;
  const moduleClass = moduleName ? `lfx-layout-module-${moduleName}` : "";
  const compactClass = moduleName === "products" && filtersCompact ? "lfx-products-filters-compact" : "";
  const gridAnchorIdx =
    moduleName === "products" && filtersCompact
      ? screen.sections.findIndex((s) => s.type === "grid")
      : -1;

  return (
    <div className={`lfx-layout cols-${cols} ${moduleClass} ${compactClass}`.trim()}>
      {screen.sections?.map((section, i) => (
        <div
          key={i}
          id={i === gridAnchorIdx ? "shop-filters-anchor" : undefined}
          className={`lfx-section-wrap span-${section.span || 1}`}
        >
          <SectionRenderer section={section} actions={actions} />
        </div>
      ))}
    </div>
  );
}

function SectionRenderer({ section, actions }) {
  switch (section.type) {
    case "form":   return <FormSection section={section} actions={actions} />;
    case "grid":   return <GridSection section={section} actions={actions} />;
    case "cart":   return <CartSection section={section} />;
    case "landing": return <LandingSection section={section} />;
    default:       return null;
  }
}
